import { appConfig } from '@/config/app'
import type { TelegramLoginResponse } from '@/types/api'

type IdBootstrapResponse = {
  ok: true
  token: string
  user: TelegramLoginResponse['user']
}

const buildUrl = (path: string): string => {
  const base = appConfig.api.baseUrl.replace(/\/+$/, '')
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${base}${normalizedPath}`
}

export const idAuthApi = {
  bootstrapAppSession: async (): Promise<TelegramLoginResponse | null> => {
    try {
      const response = await fetch(buildUrl('/id/session/bootstrap'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: '{}',
      })

      if (response.status === 401) {
        return null
      }

      if (!response.ok) {
        console.error('[idAuthApi] bootstrap failed', response.status)
        return null
      }

      const body = (await response.json()) as IdBootstrapResponse
      return {
        token: body.token,
        user: body.user,
      }
    } catch (error) {
      console.error('[idAuthApi] bootstrap request failed', error)
      return null
    }
  },
}
